import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const SettingsServer = {
    Notice: {
        /**
         * 公告列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/notice/list`,
                { params }
            );
        },
        /**
         * 创建公告
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/notice/add`, params);
        },
        /**
         * 修改公告信息
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/notice/update`,
                params
            );
        },
        /**
        * 修改公告状态
        */
        enabled: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/notice/update`,
                { ...params, Status: params.Status ? 1 : 2 }
            );
        },
        /**
         * 删除公告
         */
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/notice/delete`,
                params
            );
        },
    },
    Config: {
        /**
       * 配置列表
       */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/config/list`,
                { params }
            );
        },
        /**
         * 创建配置
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/config/add`, params);
        },
        /**
         * 修改配置信息
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/config/update`,
                params
            );
        },
        /**
        * 修改配置状态
        */
        enabled: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/config/update`,
                { ...params, Status: params.Status ? 1 : 2 }
            );
        },
        /**
         * 删除配置
         */
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/config/delete`,
                params
            );
        },
    },
    Email: {
        // 邮件配置列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/email-config/list`,
                { params }
            );
        },
         
        // 修改邮件配置
        modify: async (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/email-config/update`,
                { ...params }
            );
        },
    },
    Banner: {        
        /**
       * banner列表
       */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/carousel/list`,
                { params }
            );
        },
        /**
         * 创建banner
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/carousel/add`, params);
        },
        /**
         * 修改banner信息
         */
        modify: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/carousel/update`,
                params
            );
        },
        /**
         * 删除banner
         */
        delete: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/carousel/delete`,
                { params }
            );
        },
    }
}